import {
    BannersEditMassActions,
    CHANGE_MASS_ACTIONS_LINK_BULK_PATH_REPLACEMENT_DOMAIN_TUMBLER_EDITOR,
    CHANGE_MASS_ACTIONS_LINK_BULK_PATH_REPLACEMENT_NEW_PART_URL_EDITOR,
    CHANGE_MASS_ACTIONS_LINK_BULK_PATH_REPLACEMENT_PARAMETER_TUMBLER_EDITOR,
    CHANGE_MASS_ACTIONS_LINK_BULK_PATH_REPLACEMENT_SITE_LINKS_TUMBLER_EDITOR,
    CHANGE_MASS_ACTIONS_LINK_BULK_PATH_REPLACEMENT_TARGET_PART_URL_EDITOR,
    CLOSE_MASS_ACTIONS_LINK_BULK_PATH_REPLACEMENT_EDITOR,
    OPEN_MASS_ACTIONS_LINK_BULK_PATH_REPLACEMENT_EDITOR,
    SAVE_MASS_ACTIONS_LINK_BULK_PATH_REPLACEMENT_EDITOR
} from '../../../actions/banners-edit/banners-edit-mass-actions';
import { BannersEditMassActionsState } from '../../../typings/bannersEditState';
import { State } from '../../../typings/state';

import { bannersEditMassActionsInitialState } from './banners-edit-mass-actions';

export function bannersEditMassActionsLinkPathReplaceReducer(
    state: BannersEditMassActionsState = bannersEditMassActionsInitialState,
    action: BannersEditMassActions,
    fullState: State
): BannersEditMassActionsState {
    switch (action.type) {
        case OPEN_MASS_ACTIONS_LINK_BULK_PATH_REPLACEMENT_EDITOR:
            return {
                ...state,
                [action.massActionId]: {
                    ...state[action.massActionId],
                    visibleModalActions: {
                        ...state[action.massActionId].visibleModalActions,
                        linkPathBulkReplacementEditorVisible: true
                    }
                }
            };

        case SAVE_MASS_ACTIONS_LINK_BULK_PATH_REPLACEMENT_EDITOR:
        case CLOSE_MASS_ACTIONS_LINK_BULK_PATH_REPLACEMENT_EDITOR:
            return bannersEditMassActionsInitialState;

        case CHANGE_MASS_ACTIONS_LINK_BULK_PATH_REPLACEMENT_TARGET_PART_URL_EDITOR:
            return {
                ...state,
                [action.massActionId]: {
                    ...state[action.massActionId],
                    data: {
                        ...state[action.massActionId].data,
                        targetPartUrl: action.targetPartUrl
                    }
                }
            };

        case CHANGE_MASS_ACTIONS_LINK_BULK_PATH_REPLACEMENT_NEW_PART_URL_EDITOR:
            return {
                ...state,
                [action.massActionId]: {
                    ...state[action.massActionId],
                    data: {
                        ...state[action.massActionId].data,
                        newPartUrl: action.newPartUrl
                    }
                }
            };

        case CHANGE_MASS_ACTIONS_LINK_BULK_PATH_REPLACEMENT_DOMAIN_TUMBLER_EDITOR:
            return {
                ...state,
                [action.massActionId]: {
                    ...state[action.massActionId],
                    data: {
                        ...state[action.massActionId].data,
                        isDomainAndPathTumblerChecked: !state[action.massActionId].data.isDomainAndPathTumblerChecked,
                        isParametersTumblerChecked:
                            !state[action.massActionId].data.isDomainAndPathTumblerChecked === false
                                ? true
                                : state[action.massActionId].data.isParametersTumblerChecked
                    }
                }
            };

        case CHANGE_MASS_ACTIONS_LINK_BULK_PATH_REPLACEMENT_PARAMETER_TUMBLER_EDITOR:
            return {
                ...state,
                [action.massActionId]: {
                    ...state[action.massActionId],
                    data: {
                        ...state[action.massActionId].data,
                        isParametersTumblerChecked: !state[action.massActionId].data.isParametersTumblerChecked,
                        isDomainAndPathTumblerChecked:
                            !state[action.massActionId].data.isParametersTumblerChecked === false
                                ? true
                                : state[action.massActionId].data.isDomainAndPathTumblerChecked
                    }
                }
            };

        case CHANGE_MASS_ACTIONS_LINK_BULK_PATH_REPLACEMENT_SITE_LINKS_TUMBLER_EDITOR:
            return {
                ...state,
                [action.massActionId]: {
                    ...state[action.massActionId],
                    data: {
                        ...state[action.massActionId].data,
                        isSiteLinksTumblerChecked: !state[action.massActionId].data.isSiteLinksTumblerChecked
                    }
                }
            };

        default:
            return state;
    }
}
